import { UploadFieldBlock } from '../../blocks'
import Title from '../upload/field-title'
import CreationToolUploadField from '../../../types/upload-field'
import { SyntheticEvent } from 'react'

type Props = {
    className?: string
    field: CreationToolUploadField
    description?: string
    onChange: (videoDescription: string) => void
}

const CreationSourceVideoDescriptionField = ({ className, field, description = '', onChange }: Props) => {
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLTextAreaElement, InputEvent>) => {
        onChange(e.currentTarget.value || '')
    }

    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <textarea
                {...{
                    defaultValue: description,
                    placeholder: 'Add a default description for Clip uploads',
                    maxLength: maxLength || undefined,
                    onInput,
                }}
            />
        </UploadFieldBlock>
    )
}

export default CreationSourceVideoDescriptionField
